/**
 * Builds the nested Record workspace URL under a job's Records tab.
 */
export function getRecordWorkspacePath(input: {
	orgId: string;
	jobId: string;
	recordId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "form";
	return `/web/${input.orgId}/jobs/${input.jobId}/workspace/records/${input.recordId}/workspace/${tab}`;
}

/**
 * Builds the Record detail drawer URL for a job-scoped record instance.
 */
export function getRecordDrawerDetailsPath(input: {
	orgId: string;
	jobId: string;
	recordId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "details";
	return `/web/${input.orgId}/jobs/${input.jobId}/workspace/records/${input.recordId}/${tab}`;
}
